ch-action-group-item[floating] {
  visibility: hidden;
}